export default __webpack_public_path__ + "static/media/product-detail-image-3.19e1c635.svg";